export default class EventoListController {
  constructor($state, Group, UIService, Evento, EventoService, EventoTipo, Abrangencia, Papel, Investigador, User) {
    this.$state = $state;
    this.Group = Group;
    this.UI = UIService;
    this.Evento = Evento;
    this.EventoService = EventoService;
    this.EventoTipo = EventoTipo;
    this.Abrangencia = Abrangencia;
    this.Papel = Papel;
    this.Investigador = Investigador;
    this.User = User;

    this.dataLoaded = false;

    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.eventosTipo = [];
    this.abrangencias = [];
    this.papeis = [];
    this.investigadores = [];
    this.users = [];

    this.filtersLoaded = [1, 0, 0, 0, 0, 0];

    this.opt = $state.params;

    this.displayColumns = [
      { displayName: 'ID SGI', name: 'id', visible: false, sortable: true },
      { displayName: 'Designação', name: 'designacao', visible: true, sortable: true },
      { displayName: 'Slug', name: 'slug', visible: false, sortable: true },
      { displayName: 'Local', name: 'local', visible: true, sortable: true },
      { displayName: 'Ano', name: 'ano', visible: true, sortable: true },
      { displayName: 'Tipo de Evento', name: 'eventoTipo', visible: true, sortable: true },
      { displayName: 'Abrangência', name: 'abrangencia', visible: true, sortable: true },
      { displayName: 'Papel do ISR', name: 'papel', visible: true, sortable: true },
      { displayName: 'Responsável ISR', name: 'responsavel', visible: true, sortable: true },
      { displayName: 'Criado por', name: 'criadoPor', visible: false, sortable: true },
      { displayName: 'Pub. Frontend', name: 'publicado', visible: true, sortable: true }
    ];

    // type 's': select, 'o': plain text, 'd': date
    this.equalityFilters = [{
      val: 'a',
      name: 'Igual',
      type: 'o'
    },
      {
        val: 'b',
        name: 'Diferente',
        type: 'o'
      },
      {
        val: 'c',
        name: 'Começa por',
        type: 'o'
      },
      {
        val: 'd',
        name: 'Termina com',
        type: 'o'
      },
      {
        val: 'e',
        name: 'Contém',
        type: 'o'
      },
      {
        val: 'a',
        name: 'Igual (=)',
        type: 'd'
      },
      {
        val: 'b',
        name: 'Diferente de (≠)',
        type: 'd'
      },
      {
        val: 'c',
        name: 'Posterior a (>)',
        type: 'd'
      },
      {
        val: 'd',
        name: 'Anterior a (<)',
        type: 'd'
      },
      {
        val: 'e',
        name: 'Posterior ou igual (≥)',
        type: 'd'
      },
      {
        val: 'f',
        name: 'Anterior ou igual (≤)',
        type: 'd'
      },
      {
        val: 'a',
        name: 'Igual',
        type: 's'
      },
      {
        val: 'b',
        name: 'Diferente',
        type: 's'
      }
    ];

    this.dateFilters = this.equalityFilters.filter(x => x.type === 'd');

    this.columns = [{
      id: 'Evento.id',
      name: 'ID SGI',
      type: 'o'
    },
    {
      id: 'Evento.designacao',
      name: 'Designação',
      type: 'o'
    },
    {
      id: 'Evento.slug',
      name: 'Slug',
      type: 'o'
    },
    {
      id: 'Evento.local',
      name: 'Local',
      type: 'o'
    },
    {
      id: 'Evento.ano',
      name: 'Ano',
      type: 'o'
    },
    {
      id: 'Evento.eventoTipoId',
      name: 'Tipo de Evento',
      type: 's',
      list: this.eventosTipo
    },
    {
      id: 'Evento.abrangenciaId',
      name: 'Abrangência',
      type: 's',
      list: this.abrangencias
    },
    {
      id: 'Evento.papelId',
      name: 'Papel do ISR',
      type: 's',
      list: this.papeis
    },
    {
      id: 'Evento.responsavelId',
      name: 'Responsável ISR',
      type: 's',
      list: this.investigadores
    },
    {
      id: 'EventoOrganizacao.investigadorId',
      name: 'Membro Participante',
      type: 's',
      list: this.investigadores
    },
    {
      id: 'Evento.criadoPorId',
      name: 'Criado Por',
      type: 's',
      list: this.users
    },
    {
      id: 'Evento.publicado',
      name: 'Publicado Frontend',
      type: 's',
      list: this.simnao
    }
    ];


    // Find relevant displayColumns from local storage
    if (localStorage.getItem('ISR_SGI_DisplayColumns')) {
      let displayColumns = JSON.parse(localStorage.getItem('ISR_SGI_DisplayColumns'));
      if (displayColumns && displayColumns.evento && displayColumns.evento.length > 0) {
        displayColumns.evento.forEach(c => {
          let i = this.displayColumns.findIndex(x => x.name === c.name);
          if (i >= 0) this.displayColumns[i].visible = c.visible;
        });
      }
    }

    this.customFilters = [];

    // Find customFilters from local storage
    if (localStorage.getItem('ISR_SGI_Filters')) {
      let storageFilters = JSON.parse(localStorage.getItem('ISR_SGI_Filters'));
      if (storageFilters.evento) this.customFilters = storageFilters.evento;
    }

    // Check if something comes from the URL, replace the customFilters if so
    if (this.opt.filter) {
      this.customFilters = [];
      let filters = this.opt.filter.split(":");
      filters.forEach(filter => {
        let a = filter.split("·");
        if (a.length === 3) {
          try {
            let data = {
              column: {},
              value: {}
            };
            data.column.selected = this.columns.find(f => {
              return f.id === a[0];
            });
            if (angular.isUndefined(data.column.selected)) {
              throw Error();
            }
            this.customFilters.push(data);
          } catch (e) {
            this.customFilters = [];
            this.UI.addToast('Não foi possível carregar filtros');
          }
        }
      });
      // If updated, save it to local storage
      this.setToLocalStorage('ISR_SGI_Filters', 'evento', this.customFilters);
    }

    // Restore list to selected if exists
    this.customFilters.forEach(f => {
      if (f.column && f.column.selected) {
        if (f.column && f.column.selected) {
          if (f.column.selected.id === 'Evento.eventoTipoId')
            f.column.selected.list = this.eventosTipo;
          if (f.column.selected.id === 'Evento.abrangenciaId')
            f.column.selected.list = this.abrangencias;
          if (f.column.selected.id === 'Evento.papelId')
            f.column.selected.list = this.papeis;
          if (f.column.selected.id === 'Evento.responsavelId')
            f.column.selected.list = this.investigadores;
          if (f.column.selected.id === 'Evento.criadoPorId')
            f.column.selected.list = this.users;
          if (f.column.selected.id === 'EventoOrganizacao.investigadorId')
            f.column.selected.list = this.investigadores;
          if (f.column.selected.id === 'Evento.publicado')
            f.column.selected.list = this.simnao;
        }
      }
      // Fix date filters to be moment()
      if (f.column.selected.type === 'd') {
        f.value = moment(f.value).utc();
        f.value.second(0); // We don't care about seconds
      }
    });

    // Number of selected items
    this.nSelected = 0;
    this.everythingSelected = false;

    // Load the data for the filter panel (not mandatory just to look at the table)
    this.loadData();
    // Load the table data so we can see stuff even if nothing else works
    this.getEventos();
  }

  // Set to localStorage storageKey, to the value with the content for that value
  setToLocalStorage = (storageKey, value, content) => {
    let s = JSON.parse(localStorage.getItem(storageKey));
    if (s) { // If storageKey exists, check if value exists
      if (s[value]) {
        if (content) {
          s[value] = content;
        } else {
          delete s[value];
        }
      } else {
        if (content) {
          s[value] = content;
        } else {
          // Nothing...
        }
      }
    } else {
      if (content) {
        s = {};
        s[value] = content;
      } else {
        // Nothing...
      }
    }
    localStorage.setItem(storageKey, JSON.stringify(s));
  };



  // Add entry to whereObject (where/whereLiteral) or to whereOrObject depending if there are multiple selections of the same entry
  setWhereField = (data, whereObject, whereOrObject) => {
    // Check if have this entry in whereOr already
    if (whereOrObject.find(x => x.key === data.key)) { // If so, add it here then
      whereOrObject.push({
        key: data.key,
        value: data.value
      });
    } else { // Not in OR, check if there's an entry of this key in whereObject already
      if (whereObject[data.key]) { // Already have an entry for this key, transform it into an OR and add it and the new one
        whereOrObject.push({
          key: data.key,
          value: whereObject[data.key]
        });
        delete whereObject[data.key];
        whereOrObject.push({
          key: data.key,
          value: data.value
        });
      } else { // It's the first entry of this key, use whereObject only
        whereObject[data.key] = data.value;
      }
    }
  };

  // Returns a whereFields object to use in table() remote methods
  // WhereLiteral should be defined locally
  setWhereFields = (customFilters, literal, orsLiteral) => {
    let where = {};
    let whereDates = [];
    let whereNextDates = [];
    let whereLiteral = literal || {};
    let whereOrLiteral = orsLiteral || [];
    let whereOr = [];

    customFilters.forEach(f => {
      let data = {};
      data.key = f.column.selected.id;
      // Generated dates - Assuming if no . exists in field, it's always generated date
      if (f.column.selected.id.split('.').filter(Boolean).length === 1 && f.column.selected.type === 'd') {
        whereNextDates.push({
          key: data.key,
          comp: f.values.selected.val,
          value: f.value,
          format: f.column.selected.format
        });
      } else { // All other cases where fields exist in database
        if (f.column.selected.type === 'o') {
          data.value = f.value;

          this.setWhereField(data, where, whereOr);
        } else {
          if (f.column.selected.type === 'd') {
            whereDates.push({
              key: data.key,
              comp: f.values.selected.val,
              value: f.value,
              format: f.column.selected.format
            });
          } else {
            // if ID doesn't exist, use value (Yes/No cases where id doesn't exist but value does)
            if (f.value.selected.id)
              data.value = f.value.selected.id;
            else
              data.value = f.value.selected.value;

            this.setWhereField(data, whereLiteral, whereOrLiteral);
          }
        }
      }
    });
    return {
      where: where,
      whereDates: whereDates,
      whereNextDates: whereNextDates,
      whereLiteral: whereLiteral,
      whereOr: whereOr,
      whereOrLiteral: whereOrLiteral
    };
  };

  clearFilter = () => {
    this.setToLocalStorage('ISR_SGI_Filters', 'evento', null);
    this.customFilters = [];
    this.getEventos();
  };

  getEventos = () => {
    this.tableLoading = true;

    let whereFields = this.setWhereFields(this.customFilters);

    this.Evento.table({
      params: {
        fields: [ // edit exportEventos() too
          'Evento.id as id',
          'Evento.designacao as designacao',
          'Evento.slug as slug',
          'Evento.local as local',
          'Evento.ano as ano',
          'Evento.criadoPorId as criadoPorId',
          'Evento.publicado as publicado',
          'EventoTipo.designacao as eventoTipo',
          'Abrangencia.designacao as abrangencia',
          'Papel.designacao as papel',
          'Investigador.nome as responsavel',
          'User.name as criadoPor'
        ],
        from: ['Evento', 'EventoTipo', 'Abrangencia', 'Papel', 'Investigador', 'User', 'EventoOrganizacao'],
        referencesOrigin: [undefined, undefined, undefined, undefined, undefined, undefined, 'EventoOrganizacao.eventoId'],
        references: [undefined, 'Evento.eventoTipoId', 'Evento.abrangenciaId', 'Evento.papelId', 'Evento.responsavelId', 'Evento.criadoPorId', 'Evento.id'],
        aliases: [],
        where: whereFields.where,
        whereLiteral: whereFields.whereLiteral,
        whereDates: whereFields.whereDates,
        whereOr: whereFields.whereOr,
        whereOrLiteral: whereFields.whereOrLiteral,
        groupBy: ['Evento.id'], // Do groupBy when having N:M relation
        order: this.opt.order,
        sort: this.opt.sort,
        limit: this.opt.items,
        skip: (this.opt.page - 1) * this.opt.items,
      }
    }).$promise.then(res => {
      let page = this.opt.page;
      let items = this.opt.items;

      let total = res.count;

      this.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.start - 1 + items) >= total) {
        this.end = total;
      } else {
        this.end = Number.parseInt(this.start - 1 + items);
      }

      // Process output
      res.data.forEach(i => {

      });

      this.eventos = res.data;
      this.total = total;
      this.tableLoading = false;
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Erro na busca de eventos. Verifique a ligação");
    });
  };

  isColumnVisible = (column) => {
    let f = this.displayColumns.find(x => x.name === column);
    return _.isEmpty(f) ? false : f.visible;
  };

  selectVisibleColumns = () => {
    let options = {
      size: 'md',
      template: require('./columns.dialog.html'),
      controller: ['$dialog', '$scope', (dialog, scope) => {
        scope.title = "Editar Campos Visíveis";
        scope.displayColumns = angular.copy(this.displayColumns);

        scope.ok = () => {
          dialog.close(scope);
        };

        scope.cancel = () => {
          dialog.dismiss('cancel');
        };
      }]
    };

    let modal = this.UI.showDialog(options);

    modal.then((res) => {
      if (res && res.displayColumns) {
        this.displayColumns = angular.copy(res.displayColumns);
        // Save it to local storage
        this.setToLocalStorage('ISR_SGI_DisplayColumns', 'evento', this.displayColumns);
      }
    });
  };

  loadData = () => {
    this.EventoTipo.find({
    }).$promise.then(eventosTipo => {
      eventosTipo.forEach(t => {
        t.name = t.designacao;
      });
      this.eventosTipo = eventosTipo;
      this.filtersLoaded[1] = 1;
    }).catch(e => {
      this.eventosTipo = [];
      this.filtersLoaded[1] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Tipos de Evento).");
    });

    this.Abrangencia.find({
    }).$promise.then(abrangencias => {
      abrangencias.forEach(t => {
        t.name = t.designacao;
      });
      this.abrangencias = abrangencias;
      this.filtersLoaded[2] = 1;
    }).catch(e => {
      this.abrangencias = [];
      this.filtersLoaded[2] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Abrangências).");
    });

    this.Papel.find({
    }).$promise.then(papeis => {
      papeis.forEach(t => {
        t.name = t.designacao;
      });
      this.papeis = papeis;
      this.filtersLoaded[3] = 1;
    }).catch(e => {
      this.papeis = [];
      this.filtersLoaded[3] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Papéis ISR).");
    });

    this.Investigador.find({
    }).$promise.then(investigadores => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      investigadores.forEach(t => {
        t.name = t.nome;
      });
      this.investigadores = investigadores;
      this.filtersLoaded[4] = 1;
    }).catch(e => {
      this.investigadores = [];
      this.filtersLoaded[4] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Investigadores).");
    });

    this.User.find({
      filter: {
        where: {
          email: {like: '%isr.uc.pt'} // Only show @ISR users
        }
      }
    }).$promise.then(users => {
      // users.forEach(t => {
      //   t.name = t.designacao;
      // });
      this.users = users;
      this.filtersLoaded[5] = 1;
    }).catch(e => {
      this.users = [];
      this.filtersLoaded[5] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Utilizadores).");
    });
  };

  sort = key => {
    if (!key.sortable) {
      return;
    }
    let keyname = key.name;
    if (this.opt.order === keyname)
      this.opt.page = 1;
    this.opt.order = keyname;
    this.opt.sort = this.opt.sort === 'asc' ? 'desc' : 'asc';
    this.$state.go('app.evento.list', this.opt, {
      // prevent the events onStart and onSuccess from firing
      notify: false,
      // prevent reload of the current state
      reload: false,
      // replace the last record when changing the params so you don't hit the back button and get old params
      location: 'replace',
      // inherit the current params on the url
      inherit: true
    });
    this.getEventos();
  };

  item = val => {
    this.opt.items = val;
    this.$state.go('app.evento.list', this.opt, {
      // prevent the events onStart and onSuccess from firing
      notify: false,
      // prevent reload of the current state
      reload: false,
      // replace the last record when changing the params so you don't hit the back button and get old params
      location: 'replace',
      // inherit the current params on the url
      inherit: true
    });
    this.getEventos();
  };

  page = sum => {
    this.opt.page += sum;
    if (this.opt.page < 1)
      this.opt.page = 1;
    if (this.opt.page > Math.ceil(this.total / this.opt.items))
      this.opt.page = Math.ceil(this.total / this.opt.items);
    this.$state.go('app.evento.list', this.opt, {
      // prevent the events onStart and onSuccess from firing
      notify: false,
      // prevent reload of the current state
      reload: false,
      // replace the last record when changing the params so you don't hit the back button and get old params
      location: 'replace',
      // inherit the current params on the url
      inherit: true
    });
    this.getEventos();
  };

  openFilter = () => {
    let result = this.filtersLoaded.reduce((a, b) => a + b, 0);

    if (result !== this.filtersLoaded.length) {
      this.UI.addToast("A carregar dados para filtragem, por favor tente novamente");
      return;
    }

    if (!this.eventosTipo.length && !this.abrangencias.length && !this.papeis.length && !this.investigadores.length && !this.users.length) {
      this.UI.addToast("Erro ao carregar dados de filtragem. Por favor recarregue a página.");
      return;
    }

    this.columns.forEach(f => {
      if (f.id === 'Evento.eventoTipoId')
        f.list = this.eventosTipo;
      if (f.id === 'Evento.abrangenciaId')
        f.list = this.abrangencias;
      if (f.id === 'Evento.papelId')
        f.list = this.papeis;
      if (f.id === 'Evento.responsavelId')
        f.list = this.investigadores;
      if (f.id === 'Evento.criadoPorId')
        f.list = this.users;
      if (f.id === 'EventoOrganizacao.investigadorId')
        f.list = this.investigadores;
      if (f.id === 'Evento.publicado')
        f.list = this.simnao;
    });

    // Copy column to be used in
    this.editColumns = angular.copy(this.columns);

    // Restore list to selected
    this.customFilters.forEach(f => {
      if (f.column && f.column.selected) {
        if (f.column.selected.id === 'Evento.eventoTipoId')
          f.column.selected.list = this.eventosTipo;
        if (f.column.selected.id === 'Evento.abrangenciaId')
          f.column.selected.list = this.abrangencias;
        if (f.column.selected.id === 'Evento.papelId')
          f.column.selected.list = this.papeis;
        if (f.column.selected.id === 'Evento.responsavelId')
          f.column.selected.list = this.investigadores;
        if (f.column.selected.id === 'Evento.criadoPorId')
          f.column.selected.list = this.users;
        if (f.column.selected.id === 'EventoOrganizacao.investigadorId')
          f.column.selected.list = this.investigadores;
        if (f.column.selected.id === 'Evento.publicado')
          f.column.selected.list = this.simnao;
      }
    });
    // Copy customFilter to another variable so we can edit it all we want
    this.editCustomFilters = angular.copy(this.customFilters);
    // Show side panel
    this.fs = true;
  };

  oldColumn = ($item, i) => {
    //Infinite Scroll Magic
    i.infiniteScroll = {};
    i.infiniteScroll.numToAdd = 20;
    i.infiniteScroll.currentItems = 20;

    if ($item.type === 's')
      i.value = {};
    else
      i.value = "";

    i.addMoreItems = function () {
      i.infiniteScroll.currentItems += i.infiniteScroll.numToAdd;
    };
  };

  applyFilter = () => {
    // Parse values from sidebar
    this.editCustomFilters = _.filter(this.editCustomFilters, f => f.column && !_.isEmpty(f.value));

    // Remove list for column, no need to save it
    this.editCustomFilters.forEach(f => {
      if (f.column && f.column.selected) {
        f.column.selected.list = [];
      }
      // Fix date filters to be moment()
      if (f.column.selected.type === 'd') {
        f.value = moment(f.value).utc();
        f.value.second(0); // We don't care about seconds
      }
    });

    this.customFilters = angular.copy(this.editCustomFilters);

    this.setToLocalStorage('ISR_SGI_Filters', 'evento', this.customFilters);
    this.fs = false;
    // Go to first page for results
    this.opt.page = 1;
    this.$state.go('app.evento.list', this.opt, {
      // prevent the events onStart and onSuccess from firing
      notify: false,
      // prevent reload of the current state
      reload: false,
      // replace the last record when changing the params so you don't hit the back button and get old params
      location: 'replace',
      // inherit the current params on the url
      inherit: true
    });

    this.getEventos();
  };

  hasSelect = () => {
    return _.some(this.eventos, a => a.selected === true);
  };

  selectAll = () => {
    if (this.allSelected) { // Not all are selected, select all
      this.eventos.forEach(a => {
        a.selected = true;
      });
      this.nSelected = this.eventos.length;
    } else { // Remove all selections
      this.eventos.forEach(a => {
        a.selected = false;
      });
      this.nSelected = 0;
    }
    this.everythingSelected = false;
  };

  selectEverything = (type) => {
    if (!type) {
      this.eventos.forEach(a => {
        a.selected = false;
      });
      this.nSelected = 0;
      this.allSelected = false;
    }
    this.everythingSelected = !!type;
  };

  selectItem = () => {
    this.nSelected = _.filter(this.eventos, r => r.selected).length;
    this.allSelected = this.nSelected >= this.eventos.length;
    this.everythingSelected = false;
  };

  deleteEvento = (evento) => {
    this.EventoService.confirmDeleteEvento(evento).then(() => {
      this.getEventos();
    }).catch(error => {
      console.log(error);
      this.getEventos();
    });
  };
}

EventoListController.$inject = ['$state', 'Group', 'UIService', 'Evento', 'EventoService', 'EventoTipo', 'Abrangencia', 'Papel', 'Investigador', 'User'];
